var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H10.75V20C10.75 20.3034 10.5673 20.5768 10.287 20.6929C10.0068 20.809 9.68417 20.7449 9.46967 20.5304L1.46967 12.5304C1.32902 12.3897 1.25 12.1989 1.25 12C1.25 11.8011 1.32902 11.6103 1.46967 11.4697L9.46967 3.46969C9.68417 3.25519 10.0068 3.19103 10.287 3.30711C10.5673 3.4232 10.75 3.69668 10.75 4.00002V11.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 7.00006C22.75 6.58585 22.4142 6.25006 22 6.25006L14 6.25007C13.5858 6.25007 13.25 6.58585 13.25 7.00007C13.25 7.41428 13.5858 7.75006 14 7.75006H22C22.4142 7.75006 22.75 7.41428 22.75 7.00006Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.25C22.4142 16.25 22.75 16.5858 22.75 17C22.75 17.4143 22.4142 17.75 22 17.75H14C13.5858 17.75 13.25 17.4143 13.25 17C13.25 16.5858 13.5858 16.25 14 16.25H22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveLeft);
export default __webpack_public_path__ + "static/media/move-left.e14a7b174c63b88bb11ff2fc990b31fb.svg";
export { ForwardRef as ReactComponent };